import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step3 } from '../../../../shared/models/component-messages/mapaRE/step3';
import { CTRL_202 } from '../../../validators/202/ctrl202';
import { CTRL_203 } from '../../../validators/203/ctrl203';
import { CTRL_204 } from '../../../validators/204/ctrl204';
import { CTRL_205 } from '../../../validators/205/ctrl205';
import { TypeLieu } from '../models/TypeLieu';
@Component({
  selector: 'app-type-lieu',
  templateUrl: './type-lieu.component.html'
})
export class TypeLieuComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeLieu'
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	@Input() lieuLivraison : TypeLieu;
  @Input() rule : string;
  @Input() errorMessage : string;

  public step3 = new Step3();
  public rg1 = '_STEP_ID_1_' + CTRL_202.id + '_1';
  public rg2 = '_STEP_ID_1_' + CTRL_203.id + '_1';
  public rg3 = '_STEP_ID_1_' + CTRL_204.id + '_1';
  public rg4 = '_STEP_ID_1_' + CTRL_205.id + '_1';

  constructor() {
  }

  public ngOnInit() {
    if(this.lieuLivraison == null)
      this.lieuLivraison = new TypeLieu();      
  }
  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
}

